import { SelectReducerActions, SelectReducerState } from './types';

export const initialState: SelectReducerState = {
  optionsVisible: false,
  searchPhrase: '',
  placeholderContent: '',
  filteredOptions: [],
  inSelectionMode: false,
  selectionIndex: 0,
};

export const selectReducer = (
  state: SelectReducerState,
  action: SelectReducerActions
) => {
  switch (action.type) {
    case 'SET_SELECTION_MODE':
      return {
        ...state,
        inSelectionMode: action.payload.inSelectionMode,
      };
    case 'SET_SELECTION_INDEX':
      return {
        ...state,
        selectionIndex: action.payload.index,
      };
    case 'SET_SEARCH_PHRASE':
      return {
        ...state,
        searchPhrase: action.payload.searchPhrase,
      };
    case 'SET_PLACEHOLDER':
      return {
        ...state,
        placeholderContent: action.payload.placeholder,
      };
    case 'SET_FILTERED_OPTIONS':
      return {
        ...state,
        filteredOptions: action.payload.options,
      };
    case 'SHOW_OPTIONS':
      return {
        ...state,
        optionsVisible: true,
      };
    case 'HIDE_OPTIONS':
      return {
        ...state,
        optionsVisible: false,
        filteredOptions: [],
      };
    default:
      return state;
  }
};
